import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import IllustrationLayout from "layouts/authentication/components/IllustrationLayout";

import bgImage from "assets/images/louder/login.png";
import { setToken } from "auth/token";
import axios from "axios";
import config from "../../../../config";

function Illustration() {
  const { t } = useTranslation();

  const [personalEmail, setPersonalEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg(null);
    setLoading(true);

    try {
      const res = await axios.post(`${config.BACKEND_BASE_URL}/api/admin/authentication/login`, {
        personalEmail,
        password,
      });

      setToken(res.data.token);

      const from = location.state?.from || "/dashboards/analytics";
      navigate(from, { replace: true });
    } catch (err) {
      if (err.response) {
        setErrorMsg(
          err.response.data?.error ||
          err.response.data?.message ||
          "Login failed"
        );
      } else {
        setErrorMsg(t("auth.networkError"));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <IllustrationLayout
      title={t("auth.signInTitle")}
      description={t("auth.signInDesc")}
      illustration={bgImage}
    >
      <MDBox component="form" role="form" onSubmit={handleSubmit}>
        <MDBox mb={2}>
          <MDInput
            type="email"
            label="Email"
            fullWidth
            value={personalEmail}
            onChange={(e) => setPersonalEmail(e.target.value)}
          />
        </MDBox>
        <MDBox mb={2}>
          <MDInput
            type="password"
            label="Password"
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </MDBox>

        {errorMsg && (
          <MDBox mt={2}>
            <MDTypography variant="button" color="error">
              {errorMsg}
            </MDTypography>
          </MDBox>
        )}

        <MDBox mt={4} mb={1}>
          <MDButton type="submit" variant="gradient" color="info" size="large" fullWidth disabled={loading}>
            {loading ? t("auth.signingIn") : t("auth.signIn")}
          </MDButton>
        </MDBox>

        <MDBox mt={2} textAlign="center">
          <MDTypography variant="button" color="text">
            <MDTypography
              component={Link}
              to="/authentication/forgot-password"
              variant="button"
              color="info"
              fontWeight="medium"
              textGradient
            >
              {t("auth.forgotPassword")}
            </MDTypography>
          </MDTypography>
        </MDBox>

        <MDBox mt={2} textAlign="center">
          <MDTypography variant="button" color="text">
            {t("auth.noAccount")}{" "}
            <MDTypography
              component={Link}
              to="/authentication/register"
              variant="button"
              color="info"
              fontWeight="medium"
              textGradient
            >
              {t("auth.register")}
            </MDTypography>
          </MDTypography>
        </MDBox>
      </MDBox>
    </IllustrationLayout>
  );
}

export default Illustration;
